import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ClientView from '../components/ClientView';
import ExecutiveSummary from '../components/ExecutiveSummary';
import { getAudit, saveAudit } from '../utils/storage';
import { exportReportToPDF } from '../utils/export';

export default function ClientShare() {
  const { auditId } = useParams();
  const [audit, setAudit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [showExec, setShowExec] = useState(false);

  useEffect(() => {
    getAudit(auditId).then(data => {
      setAudit(data);
      setLoading(false);
    });
  }, [auditId]);

  if (loading) {
    return (
      <div className="text-center py-20">
        <div className="text-brand-gold animate-pulse font-display text-xl">Loading...</div>
      </div>
    );
  }

  if (!audit) {
    return (
      <div className="text-center py-20">
        <p className="text-neutral-400">Audit not found.</p>
      </div>
    );
  }

  const handleExport = async () => {
    setExporting(true);
    try {
      await exportReportToPDF('client-report', `WhatsNEXT-Client-${audit.intake?.conceptName || 'Report'}.pdf`);
    } catch (err) { console.error('PDF export error:', err); }
    setExporting(false);
  };

  const handleUpdateAudit = async (updated) => {
    setAudit(updated);
    try {
      await saveAudit(updated);
    } catch (err) {
      console.warn('Client save failed (may not be authenticated):', err.message);
      // Save to localStorage as fallback for client-side progress
      localStorage.setItem(`roadmap_${auditId}`, JSON.stringify(updated.roadmapProgress || {}));
      localStorage.setItem(`roadmap_comments_${auditId}`, JSON.stringify(updated.roadmapComments || []));
    }
  };

  return (
    <div>
      <div className="fixed top-4 right-4 z-40 flex gap-2">
        <button onClick={() => setShowExec(true)} className="btn-secondary text-xs py-2">Exec Summary</button>
        <button onClick={handleExport} disabled={exporting} className="btn-primary text-xs py-2 disabled:opacity-50">
          {exporting ? 'Exporting...' : 'Export PDF'}
        </button>
      </div>

      {showExec && (
        <div className="fixed inset-0 bg-black/90 z-50 overflow-auto flex flex-col items-center py-8 px-4" onClick={() => setShowExec(false)}>
          <div className="mb-4 flex gap-3">
            <button onClick={async (e) => { e.stopPropagation(); await exportReportToPDF('exec-summary', `WhatsNEXT-ExecSummary-${audit.intake?.conceptName}.pdf`); }} className="btn-primary text-xs py-2">Download PDF</button>
            <button onClick={() => setShowExec(false)} className="btn-ghost text-xs">Close</button>
          </div>
          <div onClick={(e) => e.stopPropagation()} className="shadow-2xl rounded-lg overflow-hidden">
            <ExecutiveSummary audit={audit} />
          </div>
        </div>
      )}

      <ClientView audit={audit} onUpdateAudit={handleUpdateAudit} />
    </div>
  );
}
